'use strict';

angular.module('app.user')
    .config(['$stateProvider', 'RouteProvider', function($stateProvider, RouteProvider) {
        // Login form
        $stateProvider.state(RouteProvider.create('login', {
            url: '/login?warn?message',
            component: 'loginForm',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Acceso');
            }],
            params: {
                redirect: {
                    type: 'string',
                    value: null,
                    squash: true,
                },
                params: {
                    type: 'json',
                    value: null,
                    squash: true,
                },
                error: {
                    type: 'string',
                    value: null,
                    squash: true,
                },
                warn: {
                    type: 'string',
                    value: null,
                    squash: true,
                },
                message: {
                    type: 'string',
                    value: null,
                    squash: true,
                },
            },
            secure: false,
            redirectIf: {
                logged: 'front',
            },
            resolve: {
                onLogin: ['$transition$', '$state', 'GTM', 'AccountManager', function($transition$, $state, GTM, AccountManager) {
                    var targetState = $transition$.params().redirect || 'studies';
                    var targetParams = $transition$.params().params || {};

                    return function() {
                        GTM.pushEvent({
                            event: 'login',
                            origin: 'portal',
                            userId: AccountManager.getLoggedUser().id,
                        });

                        return $state.go(targetState, targetParams);
                    };
                }],
                message: ['$transition$', 'ErrorMessages', function($transition$, ErrorMessages) {
                    var paramValue = $transition$.params().message;

                    return paramValue ? ErrorMessages.get(paramValue) : null;
                }],
                warn: ['$transition$', 'ErrorMessages', function($transition$, ErrorMessages) {
                    var paramValue = $transition$.params().warn;

                    return paramValue ? ErrorMessages.get(paramValue) : null;
                }],
                error: ['$transition$', 'ErrorMessages', function($transition$, ErrorMessages) {
                    var paramValue = $transition$.params().error;

                    return paramValue ? ErrorMessages.get(paramValue) : null;
                }],
            },
        }));

        // Registration form
        $stateProvider.state(RouteProvider.create('signup', {
            url: '/signup/{invitationCode:[0-9a-zA-Z]*}',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Registro');
            }],
            component: 'signupForm',
            params: {
                invitationCode: {
                    value: '',
                    squash: true,
                },
            },
            secure: false,
            redirectIf: {
                logged: 'front',
            },
            resolve: {
                invitation: ['$q', '$transition$', 'InvitationsManager', function($q, $transition$, InvitationsManager) {
                    var invitationCode = $transition$.params().invitationCode;
                    var promise = $q.resolve();

                    if (invitationCode) {
                        promise = promise
                            .then(function() {
                                return InvitationsManager.getInvitation(invitationCode);
                            })
                            .catch(function(error) {
                                return null;
                            });
                    }

                    return promise;
                }],
                onPendingSignUp: ['$state', function($state) {
                    return ['userProfile', function(userProfile) {
                        return $state.go('signup-pending', {
                            user: userProfile,
                        });
                    }];
                }],
                onActiveSignUp: ['$state', function($state) {
                    return ['userProfile', function(userProfile) {
                        return $state.go('signup-success');
                    }];
                }],
            },
        }));
        // If user is pending after a valid registration
        $stateProvider.state(RouteProvider.create('signup-pending', {
            url: '/signup/pending?user',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Registro', null, 'Referred to user signup');
            }],
            component: 'signupPending',
            secure: false,
            redirectIf: {
                logged: 'front',
            },
            params: {
                user: {
                    type: 'json',
                    value: {},
                },
            },
            resolve: {
                user: ['$transition$', function($transition$) {
                    return $transition$.params().user;
                }],
            },
        }));
        // If user is active after a valid registration
        $stateProvider.state(RouteProvider.create('signup-success', {
            url: '/signup/success?user',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Registro', null, 'Referred to user signup');
            }],
            component: 'signupSuccess',
            secure: false,
            redirectIf: {
                logged: 'front',
            },
            params: {
                user: {
                    type: 'json',
                    value: {},
                },
            },
        }));

        // Link from a validation email
        $stateProvider.state(RouteProvider.create('validate', {
            url: '/validate-email/{userId:int}/:activationHash',
            secure: false,
            resolve: {
                validate: ['AccountManager', '$transition$', function(AccountManager, $transition$) {
                    var stateParams = $transition$.params();

                    return AccountManager.validate(stateParams.userId, stateParams.activationHash);
                }],
            },
            redirectTo: function(transition, state) {
                var validatePromise = transition.injector().getAsync('validate');

                return validatePromise.then(function(valid) {
                    return 'validate-success';
                }).catch(function(error) {
                    return 'validate-error';
                });
            },
        }));
        // Successful validation
        $stateProvider.state(RouteProvider.create('validate-success', {
            url: '/validate-email/success',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Validación de cuenta de usuario');
            }],
            secure: false,
            component: 'validateSuccess',
        }));
        // Validation with error
        $stateProvider.state(RouteProvider.create('validate-error', {
            url: '/validate-email/error',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Validación de cuenta de usuario');
            }],
            secure: false,
            component: 'validateError',
        }));

        // Recover password form ("enter your email")
        $stateProvider.state(RouteProvider.create('recover-password', {
            url: '/recover-password',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Recordar contraseña de acceso');
            }],
            secure: false,
            component: 'recoverPasswordForm',
            resolve: {
                onSubmit: ['$state', function($state) {
                    return function() {
                        return $state.go('recover-password-sent');
                    };
                }],
            },
        }));
        // Info message after form submission
        $stateProvider.state(RouteProvider.create('recover-password-sent', {
            url: '/recover-password/sent',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Recordar contraseña de acceso');
            }],
            secure: false,
            component: 'recoverPasswordSent',
        }));

        // Recover password form ("enter your new password")
        $stateProvider.state(RouteProvider.create('change-password', {
            url: '/change-password/{userId:int}/:recoverHash',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Cambiar contraseña de acceso');
            }],
            secure: false,
            component: 'changePasswordForm',
            resolve: {
                recoveryData: ['$transition$', function($transition$) {
                    var stateParams = $transition$.params();

                    return {
                        userId: stateParams.userId,
                        recoverHash: stateParams.recoverHash,
                    };
                }],/*
                validate: ['AccountManager', 'validationData', function(AccountManager, validationData) {
                    return AccountManager.allowPasswordChange(validationData.userId, validationData.recoverHash);
                }],*/
                onSubmit: ['$state', function($state) {
                    return function() {
                        return $state.go('login', {
                            message: 'password-changed',
                        });
                    };
                }],
            },
            redirect: function(transition, state) {
                var validatePromise = transition.injector().getAsync('validate');

                return validatePromise.then(function() {
                    return null;
                })
                    .catch(function(error) {
                        return 'change-password-error';
                    });
            },
        }));
        // Error message if hash in "recover password" email is not valid
        $stateProvider.state(RouteProvider.create('change-password-error', {
            url: 'change-password/error',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Cambiar contraseña de acceso');
            }],
            secure: false,
            component: 'changePasswordError',
        }));

        // Profile

        $stateProvider.state(RouteProvider.create('user', {
            url: '/user',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Cuenta de usuario');
            }],
            redirectTo: 'user.profile',
            component: 'userMain',
        }));

        $stateProvider.state(RouteProvider.create('user.profile', {
            url: '/profile',
            pageTitleComponent: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Perfil de usuario');
            }],
            component: 'userProfileDataForm',
        }));

        $stateProvider.state(RouteProvider.create('user.password', {
            url: '/password',
            pageTitleComponent: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Cambiar contraseña');
            }],
            component: 'userProfilePasswordForm',
        }));
    }]);
